export var TransportType;
(function (TransportType) {
  TransportType["XHR"] = "xhr";
  TransportType["SendBeacon"] = "beacon";
  TransportType["Fetch"] = "fetch";
})(TransportType || (TransportType = {}));